<template>
  <div class="objects-full_of">

    <div class="of_404" v-if="is404">
      <page-header>
        <h1>Объект не найден</h1>
      </page-header>
      <div class="depo-msg_dmg-wrap">
        <div class="depo-msg_dmg dmg_themable">
          <div class="dmg_text">Такого объекта в распределенном
            хранилище не найдено.</div>
        </div>
      </div>
    </div>

    <div class="of_410" v-if="is410">
      <page-header>
        <h1>Объект удален</h1>
      </page-header>
      <div class="depo-msg_dmg-wrap">
        <div class="depo-msg_dmg dmg_themable">
          <div class="dmg_text">Объект авторского права
            {{ objectId }} удален с платформы IPUniversity.</div>
        </div>
      </div>
    </div>

    <button-back
      v-if="!is404 && !is410"
      class="of_back"
      :useHistory="true"
      :defaultRoute="'/objects/search'"/>

    <div class="of_cols_oc">

      <el-scrollbar class="oc_col oc_col--left">
        <div class="oc_col-inner-wrap">
          <div v-if="isObjectBlocked"
            class="obj-blocked">
            Объект заблокирован
            <div
              v-html="objBlockCause"
              class="obj-block-cause"/>
          </div>
          <div
            v-if="canVerifyObject && type"
            class="verification-managment">
              <object-verification
                @onUpdateVerification="onUpdateVerification"
                :licensesTerms="licensesTerms"
                :typeTitle="typeTitle"
                :objDeal="objDeal"
                :objData="objData"/>
          </div>
          <div
            v-if="canBlockObject"
            class="object-managment">
              <button
                class="managment-action-btn"
                @click="showManageDialog('block')">
                Заблокировать объект
              </button>
          </div>
          <div
            v-else-if="canUnBlockObject"
            class="object-managment">
              <button
                class="managment-action-btn"
                @click="showManageDialog('unblock')">
                Разблокировать объект
              </button>
          </div>
          <div
            v-if="canDeleteObject"
            class="object-managment">
              <button
                class="managment-action-btn"
                @click="showManageDialog('delete')">
                Удалить объект
              </button>
          </div>
          <div
            v-if="canEditObject"
            class="object-managment">
              <button
                class="managment-action-btn"
                @click="$router.push({ path: `/object/edit/${objData.ObjectId}` })">
                Редактировать объект
              </button>
          </div>
          <div
            v-if="processDeleteObject()"
            class="obj-blocked">
            {{ manage.confirmText }}
          </div>
          <div class='social-share-block'
            v-if="!is404 && encURI && encTitle && !processDeleteObject() && !isObjectBlocked">
            <el-tooltip content="Поделиться в социальной сети Facebook" placement="top">
              <a :href="`https://www.facebook.com/sharer/sharer.php?u=${ encURI }`"
                target="_blank">
                <div class="share-fb"/>
              </a>
            </el-tooltip>
            <el-tooltip content="Поделиться в социальной сети ВКонтакте" placement="top">
              <a :href="`http://vkontakte.ru/share.php?url=${ encURI }&title=${ encTitle }`"
                target="_blank">
                <div class="share-vk"/>
              </a>
            </el-tooltip>
          </div>
          <router-link
            class="help-link"
            :to="{ path: '/help/33'}"
            target="_blank">
            Подробнее о карточке объекта в разделе Помощь
          </router-link>
          <div v-if="objData && objData.Title" class="of_title_ot">
            <template v-if="isAuthenticated && objData && !objData.Transient.IsBookmarked">
              <el-tooltip content="Добавить в избранные" placement="top">
                <button class="ot-add-favorite" @click="addBookmark"></button>
              </el-tooltip>
            </template>
            <template v-else-if="isAuthenticated && objData && objData.Transient.IsBookmarked">
              <el-tooltip content="Убрать из избранных" placement="top">
                <button class="ot-remove-favorite" @click="deleteBookmark"></button>
              </el-tooltip>
            </template>
            <template v-if="isAuthenticated && objData">
              <claim-add
                class="ot_claim-add"
                entity-type="Object"
                :entity-id="objData.ObjectId"/>
              <!--<el-tooltip content="Подать жалобу на объект" placement="top">
                <button class="ot-add-claim"
                  @click="showClaimDialog(objData.ObjectId, 'Object')">
                </button>
              </el-tooltip>-->
            </template>
            <img :src="`/static/grx/icons/objects/${objData.Type}.svg`"
               class="ot_icon" :class="{ [`ot_icon--${objData.Type}`]: true }">
            <div class="ot_title">{{ objData.Title }}</div>
            <div class="ot_type">{{ typeTitle }}</div>
            <div class="ot_unc"></div>
          </div>

          <div v-if="objData && objData.ObjectId" class="of_block_ob">
            <div class="ob_title">Идентификатор объекта:</div>
            <div id="of_object-id">
              <div class="of_object-id-text">{{ objData.ObjectId }}</div>
              <router-link
                :to="`/object/${objData.ObjectId}/certificate`" class="of_cert">
                <span class="of_cert-text">Сертификат</span></router-link>
            </div>
            <div class="ob_checked-msg">
              Формальная проверка объекта проведена. Конфликтов не обнаружено.</div>
            <!--<div class="of_rating" v-if="objData && objData.Rating > 0">
              <div class="ob_title">Рейтинг:</div>
              <el-rate
                disabled-void-color="#414141"
                :colors="['#e0446f', '#e0446f', '#e0446f']"
                v-model="objData.Rating"
                disabled />
            </div>-->
          </div>

          <div class="of_block_ob" style="margin: 20px 0 25px;">
            <div v-if="objData && !is404 && objDeal"
              class="smart-contract-block">
              <div class="smart-contract-title">
                Параметры смарт-контракта
              </div>
              <template v-if="objDeal.ContractId">
                <div class="smart-contract-type">
                  <img :src="objDeal.icon" class="lic_icon">
                  <h2 class="lic_title"
                    @click="usageConditionsVisible = true"
                    :title="objDeal.ContractDescription">
                    {{ objDeal.ContractTitle }}
                  </h2>
                </div>
                <template v-if="objDeal.canMakeDeals && !isObjectBlocked">
                  <button class="btn-colored-border"
                    @click="usageConditions"
                    id="of_terms-of-usage">Получить доступ к объекту</button>
                </template>
                <template v-else-if="objDeal.madeDeals">
                  <div class="made-deal">
                    {{ this.objDeal.Status }}
                  </div>
                </template>
                <template v-else-if="objDeal.cannotMakeDeals">
                  <div class="cannot-make-deal">
                    {{ this.objDeal.Status }}
                  </div>
                </template>
            </template>
            <template v-else>
              Простая (неисключительная) лицензия на использование объекта
              не указана, доступ к объекту не возможен
            </template>
            </div>
            <!--<button
              class="btn-no-border"
              v-if="contactAuthorBtnVisible"
              @click="contactAuthorInit">
              Связаться с автором</button>
            <div v-if="objData && objData.CreatedTime" class="of_created-time">
              <span class="ob_title">Депонирован:</span> {{ createdTime }}</div>
            <div v-if="objData && objData.EditedTime" class="of_edited-time">
              <span class="ob_title">Изменен:</span> {{ editedTime }}</div>-->
            <div class="object-time">
              <div v-if="objData && objData.CreatedTime" class="of_created-time">
                <span class="ob_title">Депонирован:</span> {{ createdTime }} (UTC)</div>
              <div v-if="objData && objData.EditedTime" class="of_edited-time">
                <span class="ob_title">Изменен:</span> {{ editedTime }} (UTC)</div>
            </div>
          </div>

          <div class="of_block_ob of_stat_os">
            <el-tooltip content="Количество просмотров" placement="top"
              v-if="objData && objData.Transient
                && typeof objData.Transient.ViewsNumber !== 'undefined'">
              <div class="so_el so_el--views">
                {{ objData.Transient.ViewsNumber }}</div>
            </el-tooltip>
            <el-tooltip content="Добавили в избранные" placement="top"
              v-if="objData && objData.Transient
                && typeof objData.Transient.BookmarksNumber !== 'undefined'">
              <div class="so_el so_el--bookmarked">
                {{ objData.Transient.BookmarksNumber }}</div>
            </el-tooltip>
            <el-tooltip content="Количество контрактов" placement="top"
              v-if="objData && objData.Transient
                && typeof objData.Transient.DealsNumber !== 'undefined'">
              <div class="so_el so_el--contracts">
                {{ objData.Transient.DealsNumber }}</div>
            </el-tooltip>
            <el-tooltip content="Количество цитирований" placement="top"
              v-if="objData && objData.Transient
                && typeof objData.Transient.CitesNumber !== 'undefined'">
              <div class="so_el so_el--cites">
                {{ objData.Transient.CitesNumber }}</div>
            </el-tooltip>
            <el-tooltip content="Количество включений" placement="top"
              v-if="objData && objData.Transient
                && typeof objData.Transient.IncludesNumber !== 'undefined'">
              <div class="so_el so_el--includes">
                {{ objData.Transient.IncludesNumber }}</div>
            </el-tooltip>
            <el-tooltip content="Рейтинг объекта" placement="top"
              v-if="objData && objData.Transient
                && typeof objData.Transient.Rating !== 'undefined'">
              <div class="so_el--rating">
                Суммарный рейтинг {{ objectRating }} из 100</div>
            </el-tooltip>
          </div>

          <div v-if="authors && authors.length" class="of_block_ob of_row">
            <span class="ob_title ob_title--block">
              {{ authorTitle }}<template v-if="authors.length > 1"> (
              <el-tooltip content="Авторский вклад" placement="top"
                :enterable="false">
                <i class="el-icon-question"></i>
              </el-tooltip> )</template>:</span>
            <ul class="ob_ul">
              <li v-for="(a, i) in authors" :key="`authors-${i}`">
                <router-link
                  v-if="a.userId"
                  class="ob_link"
                  :to="`/user/${a.userId}/profile/view`">{{ a.fio }}</router-link>
                <span v-else>{{ a.fio }}</span>
                <span v-if="authors.length > 1" class="ob_color-dark ob_nowrap">(
                    {{ a.stake }}
                  )</span>
                <div
                  v-if="a.affiliations"
                  v-for="(el, i) in a.affiliations"
                  class="ob_author-org"
                  :key="`author-orgs-${i}`">
                  {{ el.Organization }}
                </div>
              </li>
            </ul>
            <button
              v-if="contactBtnVisible"
              class="vivid-lnk"
              @click="contactInit">
              Связаться с контактным лицом
            </button>
          </div>

          <app-field-widget
            v-if="objData && objData.Keywords"
            title="Ключевые слова"
            classes="of_row"
            type="inline-block"
            :content="objData.Keywords"/>

          <app-field-widget
            v-if="objLicenses && objLicenses.length"
            title="Лицензии"
            classes="of_row"
            :content="objLicenses"/>

          <app-field-widget
            v-if="objData && objData.Annotation"
            title="Аннотация"
            classes="of_row"
            :content="objData.Annotation"/>

          <app-field-widget
            v-if="objData && type && objData.SubjectUDC && objData.SubjectUDC.length"
            title="Коды УДК"
            classes="of_row"
            :objType="type"
            :fieldName="'SubjectUDC'"
            :content="objData.SubjectUDC"/>

          <app-field-widget
            v-if="objData && type && objData.SubjectRCEA && objData.SubjectRCEA.length"
            title="Коды ОКВЭД 2"
            classes="of_row"
            :objType="type"
            :fieldName="'SubjectRCEA'"
            :content="objData.SubjectRCEA"/>

          <app-field-widget
            v-if="objData && objData.Software"
            title="Рекомендуемое ПО для работы с файлами"
            classes="of_row"
            :content="objData.Software"/>

          <app-field-widget
            v-if="objCountry"
            title="Страна"
            classes="of_row"
            :content="objCountry"/>

          <app-field-widget
            v-if="objData && objData.Organizations"
            title="Организации"
            classes="of_row"
            type="inline-block"
            :content="objData.Organizations"
            :contentScheme="[ 'Organization' ]"/>

          <app-field-widget
            v-if="objData && objData.ProtectionDocuments"
            title="Охранные документы"
            classes="of_row"
            type="protection-documents"
            :objData="objData"/>

          <app-reviews
            v-if="objData && objData.CreatorId"
            :objectId="objectId"
            :objectBlocked="isObjectBlocked"
            :objectCreatorId="objData.CreatorId"/>
        </div>

      </el-scrollbar>

      <el-scrollbar class="oc_col oc_col--right">
        <div class="oc_col-inner-wrap">

          <app-field-widget
            v-if="files.image && files.image.length"
            type="images"
            classes="of_row"
            :content="files.image"/>

          <app-field-widget
            v-if="files.preview && files.preview.length"
            title="Все файлы предпросмотра"
            type="files.preview"
            classes="of_row"
            :objData="objData"
            :content="files.preview"/>

          <app-field-widget
            v-if="files.body && files.body.length"
            title="Файлы объекта"
            type="files.body"
            classes="of_row"
            @onShowAccessConditions = "usageConditions()"
            :objDeal="objDeal"
            :objData="objData"
            :content="files.body"/>

          <app-field-widget
            v-if="files.legal && files.legal.length"
            title="Документы, подтверждающие сведения о правообладателях и правах"
            type="files.legal"
            classes="of_row"
            :objData="objData"
            :content="files.legal"/>

          <app-field-widget
            v-if="objData && type && objData.Transient.RelatedLinks.length !== 0"
            title="Цитирование в других объектах"
            classes="of_row"
            type="object"
            :objData="objData"/>

          <app-field-widget
            v-if="objData && type && objData.Links"
            title="Ссылки (связанные объекты и ресурсы)"
            classes="of_row"
            type="links"
            fieldName = "Links"
            :objType="type"
            :objData="objData"/>

          <template v-if="objData && type && objData.Metadata">
            <app-field-widget
              v-for="(el, name) in objData.Metadata"
              :title="typeFieldTitleByName(name)"
              :fieldName="name"
              :key="`meta-${name}`"
              classes="of_row"
              :objData="objData"
              :objType="type"
              :content="el"/>
          </template>

          <antiplagiat
            v-if="objectId !== ''"
            :objectId="objectId"
            class="app-field-widget_fd of_row"/>

        </div>
      </el-scrollbar>

    </div>

    <el-dialog
      title="Параметры смарт-контракта"
      :visible.sync="usageConditionsVisible">
      <router-link
        class="help-link"
        :to="{ path: '/help/13'}"
        target="_blank">
        Подробнее о смарт-контракте и лицензии в разделе Помощь
      </router-link>
      <div class="licenses_lic">
        <img :src="objDeal.icon" class="lic_icon">
        <h2 class="lic_title">{{ objDeal.ContractTitle }}</h2>
        <p class="lic_desc">{{ objDeal.ContractDescription }}</p>
      </div>
      <div class="obj-license-btitle">
        Установленные пределы права использования объекта
      </div>
      <ul
        v-if="objData"
        class="obj-license-terms">
        <li v-for="(o, i) in objData.LicensesTerms"
          :key="`obj-lic-terms-${i}`" class="fo_li">
          {{ licensesTerms[o] }}
        </li>
      </ul>
      <template v-if="objData && objData.LicensesInformation">
        <div class="obj-license-btitle">Дополнительные лицензионные условия</div>
        <div>{{ objData.LicensesInformation }}</div>
      </template>

      <p><span style="display: block; color: #000; font-weight: 500;">
        Доступ к цифровому объекту:</span>
        Бесплатно с учетом лицензионных ограничений.</p>
      <div v-if="isObjectBlocked" class="usage-cond-obj-blocked">
        Объект заблокирован
      </div>
      <div v-else-if="objDeal && objDeal.canMakeDeals"
        class="obj-term-of-use">
        <div class="access-conditions">
          Вы можете получить доступ к объекту
          и использовать объект на указанных выше условиях контракта
        </div>
        <el-checkbox
          v-model="objUseAgreement">
          Я согласен с условиями контракта на доступ к объекту
        </el-checkbox>
        Для подтверждения действия введите пароль:
        <el-input
          v-model="objDeal.Password"
          type="password"
          clearable
          @focus="passwordInputError=false"
          :class="[{'password-has-error': passwordInputError}, 'password-input' ]"
          :disabled="!objUseAgreement"
          :key="`password-input`"/>
      </div>
      <span slot="footer" class="dialog-footer">
          <button v-if="objDeal && objDeal.canMakeDeals && !isObjectBlocked"
            :class="[{'send-deal-inactive' : objDeal.sendingToApi || !objUseAgreement},
              'dialog-primary-btn']"
            :disabled="objDeal.sendingToApi || !objUseAgreement"
            @click="acceptUseAgreement()">
            Получить доступ
          </button>
          <button
            :class="[objDeal && objDeal.canMakeDeals ? 'dialog-empty-btn' : 'dialog-primary-btn']"
            @click="usageConditionsVisible = false">
            Закрыть окно
          </button>
      </span>

    </el-dialog>

    <el-dialog
      title="Связаться с контактным лицом"
      class="of_contact"
      :visible.sync="contactDialogVisible">

      <el-input
        type="textarea"
        :autosize="{ minRows: 5, maxRows: 10 }"
        v-model="contact.text"/>

      <label>
        <span style="color: red; font-size: 20px;">*</span>
        Ваш e-mail для обратной связи:
      </label>
      <el-input
        type="text"
        clearable
        v-model="contact.mail"/>

      <span slot="footer" class="dialog-footer">
        <button class="dialog-close-btn" @click="contactSubmit">
          Отправить</button>
      </span>

    </el-dialog>

    <el-dialog
      class="rs_popup_rp"
      :visible.sync="claim.claimDialogVisible">
      <h2 class="rp_header">
        Подать жалобу на объект
      </h2>
        <div class="block-wrap rs_block-wrap">
          <div class="dialog-message">
            Причина жалобы
          </div>
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 20 }"
            v-model="claim.message"
            :key="`claim-input`"/>
        </div>
        <div class="buttons-wrap">
          <button
            :disabled="claim.sendingToApi"
            class="vivid-button"
            @click="addClaim">
            Подать жалобу
          </button>
          <button
            class="vivid-button"
            :disabled="claim.sendingToApi"
            @click="claim.claimDialogVisible = false">
            Закрыть окно
          </button>
        </div>
      </el-dialog>

    <el-dialog
      class="rs_popup_rp"
      :visible.sync="manage.manageDialogVisible">
      <h2 class="rp_header">
        Управление объектом
      </h2>
        <div class="block-wrap rs_block-wrap confirm-text">
          {{ manage.confirmText }}
        </div>
        <div v-if="manage.action == 'block'" class="block-wrap rs_block-wrap">
          <div class="dialog-message">
            Причина блокировки
          </div>
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 20 }"
            v-model="manage.cause"
            :key="`manage-cause-input`"/>
        </div>
        <div class="buttons-wrap">
          <template v-if="manage.action === 'block' ||
            manage.action === 'unblock' ||
            manage.action === 'delete'">
            <button
              :disabled="manage.sendingToApi"
              class="vivid-button"
              @click="manageObject(manage.action)">
              Да
            </button>
            <button
              class="vivid-button"
              :disabled="manage.sendingToApi"
              @click="manage.manageDialogVisible = false">
              Нет
            </button>
          </template>
          <template v-else-if="manage.action === 'deleted'">
            <router-link :to="`/user/objects`" class="profile-link">
              Перейти к моим объектам
            </router-link>
          </template>
        </div>
      </el-dialog>

  </div>
</template>

<script>
/* eslint-disable arrow-body-style */
import Vue from 'vue';
import axios from 'axios';
import approve from 'approvejs';
import Antiplagiat from '@/components/Antiplagiat';
import licenses from '@/data/licenses';
import ClaimAdd from '@/components/ClaimAdd';
import ObjectVerification from '@/components/ObjectVerification';
import AppFieldWidget from '../AppFieldWidget';
import AppReviews from '../review/AppReviews';
import ButtonBack from '../ButtonBack';
import ObjectMixin from '../../mixins/Object';
import PageHeader from '../PageHeader';

export default {

  mixins: [ObjectMixin],

  components: { ButtonBack,
    AppFieldWidget,
    AppReviews,
    Antiplagiat,
    ClaimAdd,
    PageHeader,
    ObjectVerification,
  },

  data() {
    return {
      objectId: '',
      objData: null,
      objCountry: '',
      objLicenses: [],
      licenses,
      usageConditionsVisible: false,
      is404: false,
      is410: false,
      files: {
        image: [],
        preview: [],
        body: [],
      },
      contactDialogVisible: false,
      contact: {
        text: '',
        mail: '',
      },
      passwordInputError: false,
      objDeal: {},
      objUseAgreement: false,
      encURI: '',
      encTitle: '',
      claim: {
        entityId: '',
        entityType: '',
        message: '',
        sendingToApi: false,
        claimDialogVisible: false,
      },
      manage: {
        action: '',
        confirmText: '',
        cause: '',
        manageDialogVisible: false,
        sendingToApi: false,
      },
    };
  },

  mounted() {
    const script = document.createElement('script');
    script.setAttribute('src', '/static/js/jsrsasign-all-min.js');
    document.head.appendChild(script);
  },

  created() {
    this.fetchData();
  },

  watch: {
    $route() {
      Object.assign(this.$data, this.$options.data());
      this.fetchData();
    },
  },

  computed: {

    isObjectBlocked() {
      if (this.objData && this.objData.Transient && this.objData.Transient.IsBlocked) return true;
      return false;
    },

    objBlockCause() {
      let cause = '';
      if (this.objData && this.isObjectBlocked) {
        if (this.canVerifyObject) {
          cause = 'Вы указаны в качестве соавтора / правообладателя.<br>Сведения об объекте требуют вашей проверки и подтверждения.<br>Проверьте описание объекта, а также условия предоставления доступа к объекту';
        } else if (this.objData.Transient.Blocking.Cause) {
          cause = this.objData.Transient.Blocking.Cause;
        } else if (this.objData.Transient.Status.StatusTitle) {
          cause = this.objData.Transient.Status.StatusTitle;
          if (this.objData.Transient.Status.StatusDescription) cause = `${cause}<br>${this.objData.Transient.Status.StatusDescription}`;
        }
      }
      return cause;
    },

    contactBtnVisible() {
      return this.objData && this.objData.Contacts && this.objData.Contacts.length;
    },

    isMobile() {
      return window.innerWidth <= 830;
    },

    createdTime() {
      let time = '';
      if (this.objData && this.objData.CreatedTime) {
        const d = new Date(this.objData.CreatedTime * 1000);
        const year = d.getUTCFullYear();

        let month = d.getUTCMonth() + 1;
        if (month < 10) month = `0${month}`;

        let date = d.getUTCDate();
        if (date < 10) date = `0${date}`;

        let hours = d.getUTCHours();
        if (hours < 10) hours = `0${hours}`;

        let minutes = d.getMinutes();
        if (minutes < 10) minutes = `0${minutes}`;

        time = `${date}.${month}.${year} ${hours}:${minutes}`;
      }
      return time;
    },

    editedTime() {
      let time = '';
      if (this.objData && this.objData.EditedTime) {
        const d = new Date(this.objData.EditedTime * 1000);
        const year = d.getUTCFullYear();

        let month = d.getUTCMonth() + 1;
        if (month < 10) month = `0${month}`;

        let date = d.getUTCDate();
        if (date < 10) date = `0${date}`;

        let hours = d.getUTCHours();
        if (hours < 10) hours = `0${hours}`;

        let minutes = d.getMinutes();
        if (minutes < 10) minutes = `0${minutes}`;

        time = `${date}.${month}.${year} ${hours}:${minutes}`;
      }
      return time;
    },

    typeTitle() {
      let title = '';
      if (this.type) {
        title = this.type.Title;
      }
      return title;
    },

    type() {
      let type = null;
      if (this.objData && this.objData.Type) {
        type = this.$store.getters['types/getType'](this.objData.Type);
      }
      return type;
    },

    licensesTerms() {
      let terms = {};
      if (this.type) {
        this.type.Fields.some((field) => {
          if (field.Name === 'LicensesTerms') {
            if (field.WidgetOptions.Options) {
              terms = field.WidgetOptions.Options;
            }
            return true;
          }
          return false;
        });
      }
      return terms;
    },

    authorTitle() {
      if (this.type && this.type.Fields) {
        const fields = this.type.Fields;
        for (let i = 0; i < fields.length; i += 1) {
          if (fields[i].Name === 'Authors') {
            return fields[i].Title;
          }
        }
      }
      return 'Авторы';
    },

    authors() {
      const authors = [];
      if (this.objData && this.objData.Authors && this.objData.Authors.length) {
        const stakes = this.objData.Authors.reduce((sum, current) => {
          return sum + current.Stake;
        }, 0);
        this.objData.Authors.forEach((data, i) => {
          authors[i] = {};
          authors[i].fio = `${data.Surname} ${data.Name}`;
          authors[i].fio += data.Patronymic ? ` ${data.Patronymic}` : '';
          authors[i].stake = `${data.Stake}/${stakes}`;
          authors[i].userId = data.UserId ? data.UserId : '';
          authors[i].affiliations = data.Affiliations ? data.Affiliations : null;
        });
      }
      return authors;
    },

    isAuthenticated() {
      return this.$store.getters['user/isAuthenticated'];
    },

    objectRating() {
      if (this.objData && this.objData.Transient.Rating) {
        return Math.round((this.objData.Transient.Rating * 99) + 1);
      }
      return 0;
    },

    canBlockObject() {
      if (this.isAuthenticated && this.objData) {
        if (this.objData.Transient.Permissions.OBJECT_BLOCK === true) return true;
      }
      return false;
    },

    canUnBlockObject() {
      if (this.isAuthenticated && this.objData) {
        if (this.objData.Transient.Permissions.OBJECT_UNBLOCK === true) return true;
      }
      return false;
    },

    canDeleteObject() {
      if (this.isAuthenticated && this.objData && this.manage.action !== 'deleted') {
        if (this.objData.Transient.Permissions.OBJECT_DELETE === true) return true;
      }
      return false;
    },

    canEditObject() {
      if (this.isAuthenticated && this.objData && this.manage.action !== 'deleted') {
        if (this.objData.Transient.Permissions.OBJECT_UPDATE === true) return true;
      }
      return false;
    },

    canVerifyObject() {
      if (this.isAuthenticated && this.objData && this.manage.action !== 'deleted') {
        if (this.objData.Transient.Permissions.OBJECT_VERIFY === true
          || this.objData.Transient.Permissions.OBJECT_REJECT === true) return true;
      }
      return false;
    },

  },

  beforeRouteLeave(to, from, next) {
    this.$store.commit('clearActiveAjax');
    next();
  },

  methods: {

    onUpdateVerification() {
      Vue.$loading.on();
      setTimeout(() => {
        this.fetchData();
        Vue.$loading.off();
      }, 3000);
    },

    fetchData() {
      this.$store.commit('setObjIsLoading', true);
      this.objectId = this.$route.params.objectId;
      if (this.objectId) {
        axios.get(`objects/${this.objectId}?loadRelated=true&log=true`).then((response) => {
          this.objData = response.data;
          this.encURI = encodeURI(window.location.href);
          this.encTitle = encodeURI(this.objData.Title);
          // Get Country data
          if (this.objData && this.objData.Country) {
            axios.post('vocabularies/values', {
              voc: 'countries', q: [this.objData.Country],
            }).then((countryResponse) => {
              this.objCountry = countryResponse.data[this.objData.Country];
            });
          }
          this.files.body = [];
          this.files.preview = [];
          this.files.image = [];
          this.files.legal = [];
          if (this.objData.Files && this.objData.Files.length) {
            this.objData.Files.forEach((file) => {
              const fileAdv = Object.assign({ ObjectId: this.objData.ObjectId }, file);
              if (file.Type === 'body') {
                this.files.body.push(fileAdv);
              } else if (file.Type === 'preview') {
                if (fileAdv.MIME === 'image/jpeg'
                  || fileAdv.MIME === 'image/png'
                ) {
                  this.files.image.push(fileAdv);
                } else {
                  this.files.preview.push(fileAdv);
                }
              } else if (file.Type === 'legal') {
                this.files.legal.push(fileAdv);
              }
            });
          }
          if (!this.isAuthenticated) {
            this.$set(this.objDeal, 'cannotMakeDeals', true);
            this.$set(this.objDeal, 'ContractId', this.objData.Licenses[0]);
            this.$set(this.objDeal, 'ContractTitle', this.licenses[this.objDeal.ContractId].Title);
            this.$set(this.objDeal, 'ContractDescription',
              this.licenses[this.objDeal.ContractId].Description);
            this.$set(this.objDeal, 'icon', this.licenses[this.objDeal.ContractId].icon);
            this.$set(this.objDeal, 'Status', 'Чтобы получить доступ к объекту пройдите авторизацию');
          }
          this.$store.commit('setObjIsLoading', false);
          this.is404 = false;
          this.is410 = false;
        }).catch((err) => {
          if (err.response.status === 410) {
            this.is410 = true;
          } else {
            this.is404 = true;
            // this.$router.push({ path: '/404' });
          }
        });
        //  ToDO Не понятно как будет происходить создание/принятие
        //  нескольких контрактов на один объект.
        //  Поэтому сейчас учитываю только первый статус
        //  по возможности/не возможности заключения контракта.
        //  Когда появится механизм создания нескольких контрактов нужно будет учитывать все.
        if (this.isAuthenticated) {
          axios.get(`deals/my/object/${this.objectId}`).then((dealResponse) => {
            let curDeal = {};
            if (dealResponse.data.CanMakeDeals.length !== 0) {
              curDeal = dealResponse.data.CanMakeDeals[0];
              this.$set(this.objDeal, 'Nonce', curDeal.Nonce);
              this.$set(this.objDeal, 'canMakeDeals', true);
              this.$set(this.objDeal, 'Password', '');
              this.$set(this.objDeal, 'sendingToApi', false);
            } else if (dealResponse.data.CannotMakeDeals.length !== 0) {
              curDeal = dealResponse.data.CannotMakeDeals[0];
              this.$set(this.objDeal, 'cannotMakeDeals', true);
              this.$set(this.objDeal, 'Status', curDeal.Transient.Causes[0]);
            } else if (dealResponse.data.MadeDeals.length !== 0) {
              curDeal = dealResponse.data.MadeDeals[0];
              this.$set(this.objDeal, 'madeDeals', true);
              this.$set(this.objDeal, 'DealId', curDeal.DealId);
              this.$set(this.objDeal, 'Status', `У вас есть доступ к объекту, номер контракта ${curDeal.DealId}`);
            }
            if (curDeal.Transient) {
              this.$set(this.objDeal, 'ContractId', curDeal.ContractId);
              this.$set(this.objDeal, 'ContractName', curDeal.Transient.Contract.Name);
              this.$set(this.objDeal, 'ContractTitle', curDeal.Transient.Contract.Title);
              this.$set(this.objDeal, 'ContractDescription', curDeal.Transient.Contract.Description);
              this.$set(this.objDeal, 'icon', this.licenses[this.objDeal.ContractId].icon);
            }
          });
        }
      }
    },

    processDeleteObject() {
      if (this.manage && this.manage.action === 'deleted') return true;
      return false;
    },

    acceptUseAgreement() {
      if (!this.objDeal.Password) {
        this.passwordInputError = true;
        this.$message('Для подтверждения действия введите пароль');
      } else {
        const userData = this.$store.getters['user/getUserData'];
        if (!userData.PrivateKey) {
          this.$message('Для получения доступа к объекту обновите пароль в профиле пользователя');
        } else {
          this.objDeal.sendingToApi = true;
          axios.post('users/validatePassword', this.objDeal.Password).then(() => {
            const request = {};
            request.UserId = userData.UserId;
            request.ObjectId = this.objectId;
            request.ContractId = this.objDeal.ContractId;
            request.Nonce = this.objDeal.Nonce;
            request.Password = this.objDeal.Password;
            const signature =
              window.SignatureDealCreate(request, userData.PrivateKey, this.objDeal.Password);
            request.Signature = signature;
            axios.post('deals', JSON.stringify(request)).then((r) => {
              this.objDeal.canMakeDeals = false;
              this.objDeal.madeDeals = true;
              this.objDeal.DealId = r.data;
              this.objDeal.Status = `У вас есть доступ к объекту, номер контракта ${this.objDeal.DealId}`;
              this.$message(`Вам предоставлен доступ к объекту, номер контракта ${this.objDeal.DealId}`);
              this.usageConditionsVisible = false;
            }).catch((error) => {
              this.$message(error.response.data.join(' '));
            }).finally(() => {
              this.objDeal.sendingToApi = false;
            });
            this.$nextTick(() => { this.$forceUpdate(); });
          }).catch((error) => {
            this.$message(error.response.data);
            this.objDeal.sendingToApi = false;
          });
        }
      }
    },

    objectActions(command) {
      this[command]();
    },

    typeFieldByName(name) {
      let field = {};
      if (this.type) {
        field = this.type.Fields.find((fieldData) => {
          return fieldData.Name === name;
        });
      }
      return field;
    },

    typeFieldTitleByName(name) {
      let title = '';
      if (this.type) {
        const field = this.typeFieldByName(name);
        if (field) {
          title = field.Title;
        }
      }
      return title;
    },

    addBookmark() {
      const userId = this.$store.getters['user/getUserId'];
      if (userId && this.objData.ObjectId) {
        axios.put(`bookmarks/${userId}/${this.objData.ObjectId}`).then(() => {
          this.objData.Transient.IsBookmarked = true;
          this.objData.Transient.BookmarksNumber += 1;
        });
      }
    },

    deleteBookmark() {
      const userId = this.$store.getters['user/getUserId'];
      if (userId && this.objData.ObjectId) {
        axios.delete(`bookmarks/${userId}/${this.objData.ObjectId}`).then(() => {
          this.objData.Transient.IsBookmarked = false;
          this.objData.Transient.BookmarksNumber -= 1;
        });
      }
    },

    addClaim() {
      if (this.claim && this.isAuthenticated) {
        this.claim.sendingToApi = true;
        axios.post('claims', this.claim).then(() => {
          this.$message.success('Жалоба отправлена');
        }).catch((error) => {
          this.$message.error(error.response.data);
        }).finally(() => {
          this.claim.sendingToApi = false;
          this.claim.claimDialogVisible = false;
        });
      }
    },

    showClaimDialog(entityId, entityType) {
      if (this.processDeleteObject()) {
        this.$message.error(this.manage.confirmText);
        return;
      }
      this.claim.entityId = entityId;
      this.claim.entityType = entityType;
      this.claim.message = '';
      this.claim.sendingToApi = false;
      this.claim.claimDialogVisible = true;
    },

    usageConditions() {
      this.objUseAgreement = false;
      this.passwordInputError = false;
      this.usageConditionsVisible = true;
    },

    /* deleteDeal() {
      if (this.objDeal.DealId) {
        axios.delete(`deals/${this.objDeal.DealId}`).then(() => {

        });
      }
    }, */

    contactInit() {
      const userData = this.$store.getters['user/getUserData'];
      let mail = '';
      if (userData) {
        mail = userData.Mail;
      }
      this.contact = {
        text: '',
        mail,
      };
      this.contactDialogVisible = true;
    },

    contactSubmit() {
      const textCheck = approve.value(this.contact.text, { required: true });
      const mailCheck = approve.value(this.contact.mail, { email: true });
      if (!textCheck.approved || !mailCheck.approved) {
        this.$message.error('Введите корректные данные в оба поля.');
        return;
      }
      this.contactDialogVisible = false;
      axios.post(`users/contact/${this.objectId}`, this.contact).then(() => {
        this.$message.success('Сообщение отправлено.');
      }).catch(() => {
        this.$message.error('Сбой при отправке сообщения, попробуйте связаться позже.');
      });
    },

    showManageDialog(action) {
      if (this.processDeleteObject()) {
        this.$message.error(this.manage.confirmText);
        return;
      }
      this.manage.action = action;
      this.manage.cause = '';
      if (action === 'block') this.manage.confirmText = 'Вы действительно хотите заблокировать объект?';
      else if (action === 'unblock') this.manage.confirmText = 'Вы действительно хотите разблокировать объект?';
      else if (action === 'delete') this.manage.confirmText = 'Вы действительно хотите удалить объект?';
      this.manage.sendingToApi = false;
      this.manage.manageDialogVisible = true;
    },

    manageObject() {
      if (this.manage.action === 'block' || this.manage.action === 'unblock') this.objBlockManage();
      else if (this.manage.action === 'delete') this.objDeleteManage();
    },

    objBlockManage() {
      if (this.manage.action === 'block' && this.canBlockObject) {
        this.manage.sendingToApi = true;
        const blockData = { cause: this.manage.cause };
        axios.put(`objects/${this.objectId}/block`, blockData).then(() => {
          this.$message.success('Объект заблокирован');
        }).catch((error) => {
          this.$message.error(error.response.data);
        }).finally(() => {
          this.manage.sendingToApi = false;
          this.manage.manageDialogVisible = false;
          this.fetchData();
        });
      } else if (this.manage.action === 'unblock' && this.canUnBlockObject) {
        this.manage.sendingToApi = true;
        axios.put(`objects/${this.objectId}/unblock`).then(() => {
          this.$message.success('Объект разблокирован');
        }).catch((error) => {
          this.$message.error(error.response.data);
        }).finally(() => {
          this.manage.sendingToApi = false;
          this.manage.manageDialogVisible = false;
          this.fetchData();
        });
      }
    },

    objDeleteManage() {
      if (this.canDeleteObject) {
        this.manage.sendingToApi = true;
        axios.delete(`objects/${this.objectId}`).then(() => {
          this.manage.confirmText = 'Объект в процессе удаления';
          this.$message.success(this.manage.confirmText);
          this.manage.action = 'deleted';
        }).catch((error) => {
          this.$message.error(error.response.data);
        }).finally(() => {
          this.manage.sendingToApi = false;
        });
      }
    },

  },
};
</script>

<style lang="scss">
@import '../../styles/common/main';
.rs_popup_rp {
  .confirm-text {
    color:#fff;
  }
  .dialog-message {
    padding-bottom: 20px;
  }
  .profile-link {
    text-decoration: underline;
    color:#fff;
  }
}
.social-share-block {
  padding-top: 20px;
  a {
    margin-right: 10px;
  }
  .share-fb {
    background: 0 0 no-repeat url(/static/grx/icons/fb-share.svg);
    width: 28px;
    height: 28px;
    display: inline-block;
    &:hover{
      background: 0 0 no-repeat url(/static/grx/icons/fb-share-hover.svg);
    }
  }
  .share-vk {
    background: 0 0 no-repeat url(/static/grx/icons/vk-share.svg);
    width: 28px;
    height: 28px;
    display: inline-block;
    &:hover{
      background: 0 0 no-repeat url(/static/grx/icons/vk-share-hover.svg);
    }
  }
}
.obj-license-btitle {
  font-weight: 500;
  padding-top: 10px;
}
.obj-license-terms {
  margin-top: 0px;
  margin-bottom: 0px;
}
.licenses_lic {
  position: relative;
  padding-left: 70px;
  .lic_icon {
    width: 50px;
    height: auto;
    position: absolute;
    top: 0;
    left: 0;
  }
  .lic_title {
    line-height: 22px !important;
    margin-bottom: 5px !important;
  }
  .lic_desc {
    margin: 5px 0 15px;
    &:last-of-type {
      margin-bottom: 0;
    }
  }
  @media (max-width: 450px) {
    padding-left: 0;
    .lic_icon {
      position: static;
      float: left;
      margin-right: 10px;
    }
    .lic_title {
      line-height: 22px !important;
      margin-bottom: 5px !important;
    }
    .lic_desc {
      margin: 5px 0;
    }
  }
}
.obj-blocked {
  padding-top: 10px;
  color: #d74b88;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  .obj-block-cause {
    font-size: 14px;
    text-align: left;
  }
}
.usage-cond-obj-blocked {
  color: #d74b88;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}
.obj-term-of-use {
  padding-top: 30px;
  .access-conditions {
    color: #d74b88;
    padding-bottom: 10px;
  }
  .el-checkbox {
    padding-bottom: 10px;
    display: block;
  }
  .el-input {
    margin-top: 10px;
  }
  .password-input {
    input[type="password"] {
      color:#000;
      background-color: #fff;
    }
    :disabled {
      opacity: 0.3;
    }
  }
  .password-has-error {
    input[type="password"] {
      background: rgba(170, 0, 0, 0.3);
    }
  }
}

.el-dialog {
  .dialog-primary-btn.send-claim-inactive:disabled,
  .dialog-primary-btn.send-claim-inactive:disabled:hover,
  .dialog-primary-btn.send-deal-inactive:disabled,
  .dialog-primary-btn.send-deal-inactive:disabled:hover {
    opacity: 0.2;
    cursor: not-allowed;
  }
}

.objects-full_of {
  .of_410,
  .of_404 {
    .depo-msg_dmg-wrap {
      max-width: 1200px;
      padding: 10px;
      margin: 0 auto;
      .depo-msg_dmg {
        margin: 30px 0;
        opacity: 1;
        border: 1px dashed rgba(255, 255, 255, .4);
      }
      .dmg_text {
        margin-top: 0;
      }
    }
  }
  .object-managment {
    display: inline-block;
  }
  .object-managment,
  .verification-managment {
    padding-top: 10px;
    padding-bottom: 10px;
    .managment-action-btn {
      padding: 4px 8px;
      color: #999;
      font-size: 14px;
      position: relative;
      cursor: pointer;
      border-radius: 3.5em;
      overflow: hidden;
      background-color: rgba(170, 170, 170, 0.2);
      &:hover {
        background-color: rgba(170, 170, 170, 0.4);
      }
    }
  }
  .el-scrollbar__wrap {
    overflow-x: hidden;
  }
  .of_row {
    padding: 0 25px;
    border-radius: 10px;
    &:nth-of-type(2n+1) {
      background: #1a1a1a;
      padding: 15px 25px 18px;
      @media (max-width: 1000px) {
        padding: 12px 17px;
      }
    }
    @media (max-width: 650px) {
      padding: 0 10px;
    }
  }
}

.btn-colored-border {
  background: none;
  border: none;
  padding: 14px 18px;
  color: #fff;
  text-transform: uppercase;
  font-size: 14px;
  position: relative;
  cursor: pointer;
  z-index: 1;
  border-radius: 3.5em;
  overflow: hidden;
  &:before {
    content: "";
    display: block;
    border-radius: 3.5em;
    position: absolute;
    top: 0.15em;
    left: 0.14em;
    right: 0.14em;
    bottom: 0.15em;
    z-index: -1;
    background: #0a0a0a;
  }
  &:after {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: -2;
    background: #4b5df1;
    background: -moz-linear-gradient(left, #4b5df1 0%, #dd4472 100%);
    background: -webkit-linear-gradient(left, #4b5df1 0%,#dd4472 100%);
    background: linear-gradient(to right, #4b5df1 0%,#dd4472 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(
        startColorstr='#4b5df1', endColorstr='#dd4472',GradientType=1 );
  }
}

.btn-no-border {
  background: none;
  border: none;
  padding: 14px 18px;
  color: #fff;
  text-transform: uppercase;
  font-size: 14px;
  position: relative;
  cursor: pointer;
  z-index: 1;
  border-radius: 3.5em;
  overflow: hidden;
}
.theme-w {
  .btn-no-border {
    color: #333;
  }
  .rs_popup_rp {
    .profile-link {
      color:#fff;
    }
  }
}

.btn-no-border-icon {
  background: none;
  border: none;
  padding: 0 0 0 30px;
  color: #fff;
  text-transform: uppercase;
  font-size: 14px;
  position: relative;
  cursor: pointer;
  z-index: 1;
  border-radius: 3.5em;
  overflow: hidden;
  @include transition;
  text-align: left;
  i {
    position: absolute;
    top: 0;
    left: 0;
    font-size: 20px;
    color: lighten($color-1, 15%);
    @include transition;
  }
  &:hover {
    color: lighten($color-1, 15%);
    i {
      color: #fff;
    }
  }
  @media (max-width: 390px) {
    width: 175px;
  }
}

.of_contact {
  .el-dialog {
    max-width: 900px;
  }
  label {
    font-weight: 500;
    margin: 30px 0 10px;
    display: block;
  }
  .el-textarea__inner,
  .el-input__inner {
    background-color: #fff;
    color: #333;
  }
  ::selection {
    background: rgba(0, 0, 0, .3);
  }
  ::-moz-selection {
    background: rgba(0, 0, 0, .3);
  }
}
</style>

<style lang="scss" scoped>
@import '../../styles/common/main';

.of_back {
  position: absolute;
  left: 50%;
  margin-left: -680px;
  top: 134px;
  @media (max-width: 1440px) {
    left: 170px;
    margin-left: 0;
    top: 45px;
  }
}

.of_created-time {
  margin: 0 6px 4px 0;
  @media (max-width: 570px) {
    float: none;
    margin: 15px 0 0 15px;
  }
}
.of_edited-time {
  margin: -5px 6px 20px 0;
  @media (max-width: 1000px) {
    margin-right: 15px;
    margin-top: 0;
  }
  @media (max-width: 690px) {
    clear: both;
    margin-right: 6px;
    margin-top: -5px;
  }
  @media (max-width: 570px) {
    float: none;
    margin: 2px 0 20px 15px;
  }
}

.of_rating {
  position: absolute;
  top: 0;
  right: 0;
  text-align: right;
  @media (max-width: 500px) {
    position: relative;
    text-align: left;
    margin: 15px 0;
    .el-rate,
    .ob_title {
      display: inline-block;
    }
    .el-rate {
      top: -2px;
      position: relative;
    }
  }
}

.of_cols_oc {
  position: absolute;
  top: 114px;
  bottom: 0;
  left: 50%;
  width: 100%;
  margin-left: -600px;
  max-width: 1200px;
  .oc_col {
    width: 50%;
    position: absolute;
    top: 0;
    bottom: 0;
    &.oc_col--left {
      left: 0;
      .oc_col-inner-wrap {
        padding: 10px 20px 0;
      }
    }
    &.oc_col--right {
      left: 50%;
      .oc_col-inner-wrap {
        padding: 20px 25px 0 10px;
      }
    }
  }
  @media (max-width: 1200px) {
    left: 0;
    right: 0;
    margin-left: 0;
  }
  @media (max-width: 1000px) {
    .oc_col {
      width: 100%;
      position: static;
      display: block;
      &.oc_col--left {
        .oc_col-inner-wrap {
          padding: 25px 15px 0;
        }
      }
      &.oc_col--right {
        margin-top: 15px;
        padding-bottom: 20px;
        .oc_col-inner-wrap {
          padding: 0 15px;
        }
      }
    }
  }
}

.of_page-footer {
  display: none;
  @media (max-width: 1000px) {
    display: block;
  }
}

.of_title_ot {
  margin-bottom: 12px;
  position: relative;
  padding-left: 70px;
  .ot_icon {
    width: 55px;
    height: auto;
    position: absolute;
    left: 0;
    top: 0;
  }
  .ot_title {
    font-size: 22px;
    line-height: 25px;
    margin-bottom: 8px;
  }
  .ot_type {
    font-size: 16px;
    color: #999;
  }
  .ot-add-favorite,
  .ot-remove-favorite {
    width: 28px;
    height: 28px;
    float: right;
    margin-top: 5px;
    cursor: pointer;
  }
  .ot_claim-add {
    float: right;
    margin: 5px 10px 0 0;
  }
  .ot-add-claim {
    width: 28px;
    height: 28px;
    float: right;
    margin-top: 5px;
    margin-right: 3px;
    cursor: pointer;
    background: 0 0 no-repeat url(/static/grx/icons/claim.svg);
    &:hover {
      background-image: url(/static/grx/icons/claim-hover.svg);
    }
  }
  .ot-add-favorite {
    background: 0 0 no-repeat url(/static/grx/icons/fav-not-set.svg);
  }
  .ot-remove-favorite {
    background: 0 0 no-repeat url(/static/grx/icons/fav-set.svg);
  }
  .ot-add-favorite:hover {
    background-image: url(/static/grx/icons/fav-not-set-hover.svg);
  }
  .ot-remove-favorite:hover {
    background-image: url(/static/grx/icons/fav-set-hover.svg);
  }
  @media (max-width: 650px) {
    padding-left: 0;
    margin-bottom: 0;
    .ot_icon {
      width: 65px;
      position: static;
      display: block;
      margin: 0 auto 20px;
    }
  }
}

.of_block_ob {
  margin: 30px 0;
  clear: both;
  position: relative;
  &.ob--vivid {
    padding: 17px 20px;
    border-radius: 10px;
    background: #1a1a1a;
  }
  &.ob--trans {
    padding: 0 20px;
    border-radius: 10px;
  }
  .ob_checked-msg {
    color: #999;
    margin: 10px 0;
    text-align: center;
  }
  .ob_block {
    display: block;
    margin: 5px 0;
  }
  .ob_title {
    color: #999;
    margin-right: 5px;
    &.ob_title--block {
      margin-bottom: 8px;
      display: block;
    }
  }
  .ob_color-dark {
    color: #999;
  }
  .ob_author-org {
    color: #999;
    line-height: 17px;
    font-size: 15px;
  }
  .ob_nowrap {
    white-space: nowrap;
  }
  .ob_ul {
    margin: 8px 0;
    padding-left: 30px;
    &:last-of-type {
      margin-bottom: 0;
    }
    .ob_link {
      text-decoration: underline;
      @include transition;
      cursor: pointer;
      &:hover {
        color: lighten($color-1, 15%);
        text-decoration: none;
      }
    }
  }
  .el-icon-question {
    font-size: 14px;
    margin-bottom: -1px;
    cursor: help;
  }
  .smart-contract-block {
    width: 100%;
    padding-right: 10px;
    padding-bottom: 20px;
    .smart-contract-title {
      color: #999;
    }
    .smart-contract-type {
      position: relative;
      color: #6159e0;
      padding-left: 54px;
      padding-bottom: 30px;
      min-height: 65px;
      .lic_icon {
        width: 40px;
        height: auto;
        position: absolute;
        top: 7px;
        left: 0;
      }
      .lic_title {
        font-size: 16px;
        line-height: 18px;
        text-decoration:underline;
        text-decoration-style: dotted;
        color: lighten($color-2, 10%);
        display: inline-block;
        cursor: pointer;
        font-weight: 500;
        @include transition;
        margin: 20px 0 0;
        &:hover {
          color: $color-1;
        }
      }
    }
    .cannot-make-deal {
      color: #d74b88;
    }
    .made-deal {
      color: #d74b88;
      padding-left: 30px;
      position: relative;
      &:before {
        content: "";
        position: absolute;
        width: 24px;
        height: 24px;
        top: 0;
        left: 0;
        background: 0 0 no-repeat url(/static/grx/icons/made-deal.svg);
      }
    }
  }
}

.of_stat_os {
  margin-top: 18px;
  .so_el {
    display: inline-block;
    margin-left: 15px;
    font-size: 12px;
    padding: 5px 0 0 32px;
    height: 30px;
    vertical-align: top;
    position: relative;
    background: transparent;
    border: none;
    color: #aaa;
    &:before {
      content: '';
      width: 28px;
      height: 28px;
      float: left;
      position: absolute;
      left: 0;
      top: 0;
    }
  }
  .so_el--views:before {
    background: 0 4px no-repeat url(/static/grx/icons/count-views.svg);
  }
  .so_el--bookmarked:before {
    // background: 0 0 no-repeat url(/static/grx/icons/fav-nset.svg);
    background: 0 0 no-repeat url(/static/grx/icons/fav-not-set.svg);
  }
  .so_el--contracts:before {
    background: 0 0 no-repeat url(/static/grx/icons/count-deals.svg);
  }
  .so_el--cites:before {
    background: 0 0 no-repeat url(/static/grx/icons/count-cites.svg);
  }
  .so_el--includes:before {
    background: 0 0 no-repeat url(/static/grx/icons/count-includes.svg);
  }
  .so_el--rating {
    float: right;
    color: #aaa;
  }
  .so_el--visible {
    display: inline-block;
  }
  .el-dropdown-link {
    display: inline-block;
    font-size: 20px;
    margin-left: 20px;
    width: 30px;
    height: 20px;
    outline: none !important;
    color: #fff;
  }
}

.of_cert {
  display: inline-block;
  cursor: pointer;
  &:hover {
    .of_cert-text {
      text-decoration: none;
    }
  }
  .of_cert-text {
    font-size: 15px;
    display: inline-block;
    padding: 0 4px 0 3px;
    text-decoration: underline;
  }
  &:before {
    content: '';
    display: inline-block;
    vertical-align: middle;
    width: 16px;
    height: 16px;
    background: 0 0 no-repeat url(/static/grx/icons/certificate.svg);
  }
  /*&:after {
    content: '';
    display: inline-block;
    vertical-align: middle;
    width: 12px;
    height: 12px;
    background: 0 0 no-repeat url(/static/grx/icons/new-win.svg);
  }*/
}

#of_object-id {
  display: inline-block;
  .of_object-id-text {
    margin-right: 20px;
    display: inline-block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/ObjectFull.vue